import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    dialogContent: {
        flex: "1",
        // padding: "20px 10px 10px",
        backgroundColor: "#FFFFFF",
        maxWidth: "1180px",
        minWidth: window.isMobileView ? "" : "1180px",
    },
    box: {
        display: "flex",
        flexFlow: "column",
        height: "100%",
        // padding: "18px 10px 10px 20px",
        padding: '0px 0px 0px 0px'
    },
    header: {
        flex: "0 1 auto",
        display: "flex",
        padding: '15px 10px',
        alignItems: 'baseline',
        backgroundColor: "#454545",
        cursor: 'move',
        justifyContent: 'space-between'
    },
    content: {
        flex: "1 1 auto",
        // maxHeight: "580px",
        // overflow: "auto",
        marginBottom: "10px",
        padding: '10px 20px',
        minHeight: '74vh'
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        justifyContent: 'space-between',
        borderBottom: '1px solid #F1F1F1',
        backgroundColor: "#DFEEFF",
        padding: '0 10px'
    },
    shippingLayout: {
        "& .custom-label": {
            // marginTop: '10px !important',
        }

    },
    textEditor: {
        "& .public-DraftEditor-content": {
            minHeight: '160px',
            maxHeight: '160px',
        }
    },
    marginTopTwenty: {
        marginTop: '25px',
    },
    cardHeaderTitle: {
        display: "flex",
        alignItems: "center"
    },
    container: {
        paddingRight: '25px'
    },
    leftArea: {
        borderRight: '1px solid #d0d0d0',
        paddingRight: '15px !important',
        paddingTop: '0 !important',
    },
    rightArea: {
        paddingLeft: '15px !important',
    },
    footer: {
        flex: "0 1 40px",
        gap: '10px',
        padding: '0 20px',
        marginTop: '10px',
        background: '#f7f7f7',
        paddingTop: '10px',
        paddingBottom: '10px',
    },
    customFileButton: {
        alignItems: 'center',
        display: 'flex',
        gap: '5px',
        border: '1px solid #CACACA',
        borderRadius: '5px',
        whiteSpace: 'nowrap',
        borderRadius: '5px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    spanBtn: {
        color: 'black',
        border: '1px solid #656565',
        display: 'inline-block',
        padding: '2px 8px',
        background: '#eeeeee',
        borderRadius: '3px',
        fontSize: '14px',
        margin: '3px 3px',
        fontFamily: 'Lato',
    },
    footerRight: {
        float: "right",
        marginRight: "-8px",
        display: 'flex',
        gap: '10px'
    },
    crossButton: {
        position: "relative",
        top: "-12px",
        right: "10px",
        cursor: "pointer",
        padding: "3px",
        zIndex: "2",
        display: "block",
        "& :hover": {
            backgroundColor: "#F4F4F4",
        }
    },

    closeIcon: {
        cursor: 'pointer',
        color: 'white',
    },
    title: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#FFFFFF',
        letterSpacing: '0.02em',
    },
    labelText: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#3C4549',
        padding: "14px 0px 5px",
    },
    valueText: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#3C4549',
        padding: "6px 0",
        textTransform: 'capitalize',
    },
    backBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        color: '#454545',
        borderRadius: '4px',
        padding: '8px 16px',
        textTransform: 'uppercase',
        border: '1px solid #454545',
        cursor: 'pointer',
    },
    changeBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        backgroundColor: '#454545',
        borderRadius: '4px',
        marginRight: '5px',
        padding: '8px 16px',
        textTransform: 'uppercase',
        cursor: 'pointer',
        color: '#ffffff',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#5e5e5e',
        }
    },
    templateFooter: {
        background: '#282827',
        padding: '5px 11px',
        marginTop: '15px',
        "& p": {
            margin: 0,
            color: 'white',
            display: 'flex',
            fontSize: '13px',
            alignItems: 'center',
            justifyContent: 'center',
        }
    },
    secHeading: {
        color: '#4F4F4F',
        fontSize: '16px',
        lineHeight: '12px',
        padding: '12px 6px',
        borderBottom: '1px solid #BBBEBF',
        width: '100%',
        marginBottom: '15px',
        fontFamily: 'Lato',
        fontWeight: 600,
    },

    brandBox: {
        color: 'white',
        textAlign: 'center',
        minHeight: '198px',
        display: 'flex',
        flexFlow: 'column',
        margin: 'auto',
        "& img": {
            maxWidth: '125px',
            margin: 'auto',
        },
        "& h2": {
            fontSize: '16px',
            fontFamily: 'Lato',
            fontWeight: 'bold',
            color: 'white',
            width: '85%',
            margin: '20px auto',
        }
    },
    templateContainer: {
        margin: 'auto',
        "& .tempHeader": {
            background: '#454545',
            padding: '5px',
            display: 'flex',
            alignItems: 'center',
            "& img": {
                maxWidth: '120px',
                padding: '5px',
            }
        },
        "& .tempHeaderBottom": {
            background: '#EDEDED',
            textAlign: 'center',
            padding: '10px',
            fontSize: '16px',
            "& h3": {
                margin: 0,
            }
        },
        "& .tempContent": {
            padding: '15px',
            "& h1": {
                fontSize: '22px',
            },
            "& p": {
                margin: '5px 0px',
            }
        },
        "& img": {
            //   width: '100%',
        }
    },
    sectionHeading: {
        color: '#474747',
        borderBottom: '1px solid #d0d0d0',
        padding: '2px 0px 11px 0px',
        textTransform: 'capitalize',
    },
    sectionHeadingAccord: {
        color: '#474747',
        padding: 0,
        margin: 0,
        textTransform: 'capitalize',
    },
    formControl: {
        "& .MuiTypography-root": {
            fontSize: '14px',
            "& p": {
                margin: 0,
            }
        },
        "& .MuiFormControlLabel-root": {
            alignItems: 'center',
        },
        "& .MuiButtonBase-root": {
            padding: '5px 8px',
        }
    },
    selectBaseInput: {
        width: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        margin: '5px 0px 5px',
        backgroundColor: 'white',
        minHeight: '35.63px',
        padding: '0px 8px 0px 0px',
        height: '35.63px',
        opacity: '0.7',
        border: '0.5px solid #777D80',
        borderRadius: '4px',

        '& .MuiSelect-select.MuiSelect-select': {
            paddingRight: '10px !important',
        },

        "& .MuiInputBase-input": {
            padding: "0px 24px 0px 0px",
            minHeight: "35.63px",
            fontSize: "14px",
            color: "#4A4A4A",
            '&:focus': {
                background: 'transparent',
                borderRadius: "4px",
                outline: 0,
            },
            "&:before": {
                borderBottom: 'none !important',
            },
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'none'
        },

        "& .Mui-disabled": {
            backgroundColor: "#f3f3f3",
            color: "#4A4A4A",
            minHeight: "28.63px"
        },
        "& input::-webkit-outer-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input::-webkit-inner-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input[type=number]": {
            appearance: "textfield"
        },
    },
    previewImg: {
        width: '100%',
        borderRadius: '15px',
        margin: '10px 0',
    },
    getMdn: {
        color: 'white !important',
        textTransform: 'capitalize',
        background: '#454545',
        border: '1px solid #b8b8b8',
        margin: '4px 0px',
        padding: '5px 30px',
        textTransform: 'capitalize',
        width: '100%',
        '&:hover': {
            color: '#ffffff',
            background: '#5e5e5e',
        }
    },
    activeMdn: {
        color: 'white !important',
        width: '100%',
        textTransform: 'capitalize',
        background: '#454545',
        margin: '4px 0px',
        '&.Mui-disabled': {
            color: '#c3c3c3',
            opacity: 0.5,
        },
    },

    activeMdnAll: {
        color: 'white !important',
        textTransform: 'capitalize',
        background: '#454545',
        margin: '4px 0px',
        width: 'fit-content',
        float: 'right',
        padding: '5px 13px',
        visibility: 'hidden',
        clear: 'both',
        '&.Mui-disabled': {
            color: '#c3c3c3',
            opacity: 0.5,
        },
        '&:hover': {
            color: '#ffffff',
            background: '#5e5e5e',
        }
    },
    previewImg: {

    },
    radioInfo: {
        "& .MuiFormGroup-root": {
            display: 'flex',
            flexDirection: 'row',
            gap: '30px',
        },
        "& .MuiFormControlLabel-label": {
            fontFamily: 'Lato !important',
            fontStyle: 'normal',
            fontSize: '13px',
            fontWeight: 600,
        },
    },
    reviewBtn: {
        width: '100%',
        border: '1px solid gainsboro',
        borderRadius: '6px',
        padding: '0 10px',
        cursor: 'pointer',
        textAlign: 'center',
        "& img": {
            width: '130px',
        },
        "&:hover": {
            border: '1px solid #5a5a5a',
        },
        "& h4": {
            fontWeight: 'bold',
        },

    },

    reviewDate: {
        textAllign: 'center !important',
        fontSize: '12px',
        padding: '0px 20px'

    },
    inputFile: {
        border: '1px solid #d0d0d0',
        borderRadius: '4px',
        padding: '3px 5px',
        background: '#ffffff',
        width: '100%',
        display: 'none',
    },
    collapse: {
        "& .MuiAccordionSummary-content": {
            margin: '0px 0',
        },
        "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
        },
        "& .MuiAccordionSummary-expandIcon": {
            margin: 0,
            padding: 0,
        },
        "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: '48px',
        },
        "& .MuiAccordionSummary-root": {
            padding: '0px 0px',
            borderBottom: '1px solid #d0d0d0',
        },
        "& .MuiAccordion-root": {
            width: '100%',
            boxShadow: 'none',
            background: 'transparent',
            borderRadius: '0 !important',
        },
        "& .MuiAccordionDetails-root": {
            flexFlow: 'column',
            padding: '10px 0',
        }
    },
    imageBox: {
        justifyContent: 'center',
        background: '#f7f7f7',
        border: '2px dotted #000000',
        borderRadius: '13px',
        marginBottom: '11px',
        minHeight: '214.1px',
    },
    checkBoxBtn: {
        marginLeft: "0px",
        paddingRight: "5px",
        "& + .MuiFormControlLabel-label": {
            color: "#52575C",
            fontSize: "14px",
            width: '100%',
        },
        "& .MuiSvgIcon-root": {

        }
    },
    IdentityRadio: {
        flexDirection: 'row',
        "& .MuiTypography-root": {

        }
    },
    guardianMain: {
        borderRadius: '5px',
        border: '1px solid #d0d0d0',
        padding: '10px',
    },

    CustomFileSelection: {
        width: '100% ',
        display: 'flex',
        boxSizing: 'border-box',
        margin: '5px 0px 5px',
        backgroundColor: 'white',
        minHeight: '35.63px',
        padding: '3px 8px 0px 3px',
        height: '35.63px',
        opacity: '0.9',
        border: '0.5px solid #777d80bd',
        borderRadius: '4px',
        color: 'black',
    },
    fileExtenNotif: {
        marginBottom: '5px'
    },
    addNotification: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        marginRight: '0px',
        gap: '5px',
        marginBottom: '5px',
        cursor: 'pointer',
        width: 'fit-content',
        marginLeft: 'auto',
    },
    BeneMain: {
        display: 'flex',
        alignItems: 'center',
    },
    ChildMain: {
        border: '1px solid #c0c0c0',
        padding: '0px 10px',
        background: '#f5f5f5',
        marginTop: '0px',
        borderRadius: '10px',
        marginBottom: '7px',
        paddingTop: '12px',
        position: 'relative',
    },
    deviceInfo: {
        border: '1px solid #c0c0c0',
        padding: '14px 15px',
        background: '#f5f5f5',
        marginTop: '0px',
        borderRadius: '10px',
        marginBottom: '7px',
        position: 'relative',
    },
    childClose: {
        padding: '0 !important',
        textAlign: 'right !important',
        cursor: 'pointer',
    },
    childHeading: {
        margin: '0 4px',
        fontWeight: 600,
        color: '#303030',
        fontSize: '14px',
        textTransform: 'uppercase',
    },
    paddingFive: {
        padding: '0 5px',
    },
    checkBox: {
        marginLeft: '-6px',
        "& span": {
            fontSize: '14px',
            fontFamily: 'Lato !important',
            textTransform: 'capitalize',
        },
        "& .MuiSvgIcon-root": {
            width: '0.88em',
            height: '0.88em'
        }
    },
    socialProfileInfo: {
        border: '1px solid #cbcbcb',
        padding: '10px',
        borderRadius: '5px',
    },
    checkboxMain: {
        display: 'flex',
        alignItems: 'end'
    },
    beneficiarySelect: {
        display: 'block',
        cursor: 'pointer',
        borderRadius: '4px',
        marginBottom: '10px',
        position: 'relative',
        "& .Mui-disabled": {
            opacity: 0.5,
        },
        "& .groupCheckContain": {
                display: 'flex',
                gap: '15px',
                alignItems: 'baseline',
                position: 'absolute',
                justifyContent: 'right',
                zIndex: 555,
                right: 0,
        },
        "& .groupcheckbox": {
            right: '8px',
            top: '8px',
            width: '18px',
            height:'18px'
        }
    }
}));